import React from "react";

import { StyledCard, StyledCardHeader, StyledCardBody } from "./Card.styles";

const Card = ({ title, children }) => {
  return (
    <StyledCard>
      <StyledCardHeader>{title}</StyledCardHeader>
      <StyledCardBody>{children}</StyledCardBody>
    </StyledCard>
  );
};

export default Card;
